<template>
  <q-page class="q-px-md">
    <h1 class="text-h5">Law Firms</h1>
    <accounts-table :account-type="accountType" class="q-my-md" />
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AccountsTable from '@/iam/account/AccountsTable.vue';
import { AccountType } from '@/iam/account';

interface Data {
  accountType: number
}

export default defineComponent({
  meta: {
    title: 'Law Firms',
  },
  components: {
    AccountsTable,
  },
  data(): Data {
    return {
      accountType: AccountType.CUSTOMER,
    };
  },
});
</script>
